import React, { useState } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { AUTH_ORIGEN, CORP_BLUE, SITE_URL_LOGIN_TOKEN } from 'config/config';
import { toast } from '@jumbo/components/custom/Toast';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import { LABEL_INPUT_FONT_SIZE } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { sendLoginTokenRequest } from 'services/api';
import { validarRutSoloGuion, validarRutJunto, validarMail } from '@jumbo/utils/validaciones';

const addStyle = makeStyles(theme => ({
    previewStyle: {
        color: 'black',
        cursor: 'pointer',
        padding: 2,
        '&:hover': {
            color: CORP_BLUE,
        },
    },
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        backgroundColor: CORP_BLUE,
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: 'white',
        },
    },
    num: {
        display: 'block',
        width: '100%',
    },
}));

/* const defaultReclamo = {
    n_reclamo: '',
}; */

const ModalTokenIngreso = props => {
    const { openDialog = false, close } = props;
    const classes = addStyle();

    const [loading, setLoading] = useState(false);
    const [rut, setRut] = useState('')
    const [rutError, setRutError] = useState('')
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState('')

    const clearData = () => {
        setRut('')
        setRutError('')
        setEmail('')
        setEmailError('')
        setLoading(false);
    }
    const onCloseDialog = event => {
        clearData()
        close()
    };

    const onSubmitClick = () => {
        setLoading(true);
        let bodyFormData = new FormData();
        bodyFormData.append('email', email)
        bodyFormData.append('rut', rut)
        bodyFormData.append('url', SITE_URL_LOGIN_TOKEN)
        bodyFormData.append('origen', AUTH_ORIGEN)
        /*         let data = {
                    email: email,
                    rut: rut,
                    url: SITE_URL_LOGIN_TOKEN,
                    origen: AUTH_ORIGEN,
                } */
        sendLoginTokenRequest(bodyFormData)
            .then(res => {
                toast.success('Se han enviado a tu correo las instrucciones para acceder al sistema.')
            })
            .catch(e => {
                console.error(e)
                toast.error('Error al enviar el correo')
            })
            .finally(f => {
                setLoading(false)
                onCloseDialog()
            })

    };

    const validateForm = () => {
        if (validarRutSoloGuion(rut) && validarMail(email)) {
            if (validarRutJunto(rut)) {
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    }

    return (
        <Dialog open={openDialog} onClose={onCloseDialog}   maxWidth="xs" fullWidth >

            <DialogTitle className={classes.dialogTitleRoot}>
                <label className={classes.num}>Acceder con correo electrónico </label>
            </DialogTitle>
            <Grid container item justifyContent='center'>
                <Grid item xs={8} style={{ marginTop: 10 }}>
                <p>Ingresa tu email y tu RUN registrado y te enviaremos las instrucciones para acceder al sistema.</p>
                </Grid>
                <Grid item xs={8} style={{ marginTop: 10 }}>
                    <AppTextInput
                        InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
                        fullWidth
                        size={'small'}
                        variant="outlined"
                        label="RUN"
                        value={rut}
                        placeholder={"12345678-9"}
                        onChange={e => {
                            setRutError('')
                            const inputValue = e.target.value
                            const validInput = inputValue.replace(/[^0-9kK-]/g, '');

                            if (validInput.length <= 12) {
                                setRut(validInput);
                            } else if (validInput.length > 12) {
                                setRut(validInput.slice(0, 12));
                            }
                        }}

                        onBlur={() => {
                            if (validarRutSoloGuion(rut)) {
                                if (validarRutJunto(rut)) {
                                    setRutError('')
                                } else {
                                    setRutError('Debe ingresar un RUT válido')
                                }
                            } else {
                                setRutError('Debe ingresar un RUT válido')
                            }
                        }}
                        helperText={rutError}
                    />
                </Grid>
                <Grid item xs={8} style={{ marginTop: 10, marginBottom: 10 }}>
                    <AppTextInput
                        InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
                        fullWidth
                        size={'small'}
                        variant="outlined"
                        label="Correo"
                        value={email}
                        onChange={e => {
                            if (emailError) {
                                setEmailError('')
                            }

                            setEmail(e.target.value)
                        }}

                        onBlur={() => {
                            if (!validarMail(email)) {
                                setEmailError('Debe ingresar un correo válido')
                            } else {
                                setEmailError('')
                            }
                        }}

                        helperText={emailError}
                    />
                </Grid>
            </Grid>
            <DialogContent dividers>
                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} disabled={loading}>
                        &nbsp;Cerrar&nbsp;
                    </Button>
                    <Box ml={2}>
                        <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={validateForm()}>
                            {loading ? (
                                <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} />
                            ) : (
                                'Aceptar y Enviar'
                            )}
                        </Button>
                    </Box>
                </Box>
            </DialogContent>

        </Dialog>
    );
};

export default ModalTokenIngreso;